export default function createAddressLine(addressUnits = [], joinWith = ', ') {
  const addresses = addressUnits.reduce((acc, unit) => {
    if (unit) acc.push(unit);
    return acc;
  }, []);
  return addresses.join(joinWith);
}
